var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.52,219.77c6.13-53.85-12.08-107.93-50.3-146.35-18.8-18.9-44.5-36.7-78.65-45.3C253.79,4,191.72,26.09,160.69,84.78S40.61,133.35,26.44,234.54,81.09,447,197.79,453.1s101.68-52,165.51-76.94C412.13,357.1,469.38,300.14,478.52,219.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.52,219.77c6.13-53.85-12.08-107.93-50.3-146.35-18.8-18.9-44.5-36.7-78.65-45.3C253.79,4,191.72,26.09,160.69,84.78S40.61,133.35,26.44,234.54,81.09,447,197.79,453.1s101.68-52,165.51-76.94C412.13,357.1,469.38,300.14,478.52,219.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.93,284h0a.09.09,0,0,0-.05-.12.1.1,0,0,0-.13.05A129.3,129.3,0,0,0,410,305.2a201.71,201.71,0,0,0-3.76,22.11l-.53,5.59c-.08.93-.18,1.86-.25,2.8l-.15,2.8c-.08,1.87-.2,3.74-.25,5.61l.05,5.62.06,2.81c.05.93.11,1.86.18,2.8.14,1.86.25,34.83.42,36.69.36,3.72.92,7.43,1.5,11.11a.1.1,0,0,0,.09.09.1.1,0,0,0,.1-.1h0c0-1.87-.09-3.73-.13-5.59s-.21-3.72-.19-5.58,0-34.81-.06-36.67l0-2.78,0-2.79,0-5.56.15-5.56.06-2.79c0-.92.11-1.85.16-2.78l.34-5.55a197.86,197.86,0,0,1,3.15-22.06A129.89,129.89,0,0,1,416.93,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.73,313.06a.11.11,0,0,0-.06-.13.11.11,0,0,0-.13.07,132.08,132.08,0,0,0-4,14.13,134.23,134.23,0,0,0-2.34,14.52c-.49,4.87-1,9.75-1.1,14.64s0,40.89.52,45.78a.09.09,0,0,0,.08.09.09.09,0,0,0,.11-.09c.57-4.87.91-40.83,1.25-45.69s.39-9.73.71-14.6a146.44,146.44,0,0,1,4.92-28.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86,323.29a.11.11,0,0,0-.14,0,49.31,49.31,0,0,0-10.78,9.41,42.91,42.91,0,0,0-4.22,5.86l-.87,1.64-.67,1.7a15.23,15.23,0,0,0-.6,1.72c-.17.58-.37,1.16-.52,1.74-1.21,4.68-2,40.54-2.23,45.33a81.7,81.7,0,0,0,.53,14.33.11.11,0,0,0,.09.08.09.09,0,0,0,.11-.09l1.23-14.19c.49-4.69.79-40.5,1.79-45.08.13-.57.3-1.13.44-1.69a15.51,15.51,0,0,1,.5-1.68l.57-1.64.75-1.54a41.53,41.53,0,0,1,3.86-5.87,48.58,48.58,0,0,1,10.13-9.86h0A.1.1,0,0,0,433.86,323.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.05,341.52a15.6,15.6,0,0,0-4.9,5.9,34.66,34.66,0,0,0-2.75,7.22c-.19.62-.35,1.25-.48,1.87l-.45,1.89c-.22,1.27-.4,33.64-.47,34.93s-.06,2.57,0,3.85a33.08,33.08,0,0,0,.51,3.84.1.1,0,0,0,.08.07.09.09,0,0,0,.11-.07,33.74,33.74,0,0,0,.68-3.78c.2-1.24.4-2.49.55-3.73s.34-2.47.44-3.71.26-33.59.53-34.8a33.63,33.63,0,0,1,2.1-7.16,15.86,15.86,0,0,1,4.12-6.15h0a.12.12,0,0,0,0-.13A.1.1,0,0,0,426.05,341.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,355.73c-.53-6.3-1.57-12.53-2.55-18.76s-2.07-12.45-3.21-18.65-2.42-12.38-3.75-18.54a.12.12,0,0,0-.12-.08.1.1,0,0,0-.08.11c1.08,6.21,2.06,12.44,3,18.67s1.83,12.46,2.62,18.71,1.37,12.51,2.15,18.75l2.31,49.84a.09.09,0,0,0,.09.09.1.1,0,0,0,.1-.09c.07-1.58.08-3.16.12-4.75s-.07-3.16-.1-4.74C403.93,393.13,403.67,358.88,403.43,355.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.65,355.64c-.34-2.49-.79-5-1.27-7.45l-.88-3.67c-.29-1.23-.57-2.46-.93-3.67a103.38,103.38,0,0,0-4.81-14.32L391,324.8l-.84-1.7c-.53-1.14-1.17-2.23-1.79-3.33a27.75,27.75,0,0,0-4.54-6,.1.1,0,0,0-.14.14h0a27.85,27.85,0,0,1,4.16,6.17c.55,1.12,1.12,2.22,1.59,3.38l.74,1.71.66,1.75a104.17,104.17,0,0,1,4.2,14.33c.57,2.42.95,4.89,1.42,7.33l.59,3.69c.21,1.23.47,2.45.65,3.68.39,2.47.84,36,1.27,38.48s.84,4.94,1.36,7.41a.11.11,0,0,0,.09.08.09.09,0,0,0,.1-.1c0-2.52,0-5-.17-7.55S399.91,358.15,399.65,355.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.44,356c-1.17-3.3-2.52-6.54-4-9.71a87.74,87.74,0,0,0-5-9.19.11.11,0,0,0-.14,0,.11.11,0,0,0,0,.14,86.71,86.71,0,0,1,4.28,9.48c1.28,3.22,2.43,6.49,3.39,9.81s1.7,37.8,2.58,41.13,1.68,6.69,2.7,10.06a.11.11,0,0,0,.09.08.12.12,0,0,0,.11-.1,51.12,51.12,0,0,0-1-10.48C396.82,393.68,395.6,359.26,394.44,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.22,398.07a22.38,22.38,0,0,0-2.77-5.82c-1.14-1.82-2.45-34.65-4-36.11a19.16,19.16,0,0,0-2.57-1.93,10.47,10.47,0,0,0-2.91-1.32.11.11,0,0,0-.12.05.1.1,0,0,0,.05.13h0a14.48,14.48,0,0,1,4.82,3.75c1.37,1.52,2.46,34.37,3.37,36.19s1.45,3.81,2.28,5.67c.37,1,.73,1.92,1.16,2.87a21.68,21.68,0,0,0,1.26,2.91h0a.11.11,0,0,0,.09,0,.09.09,0,0,0,.1-.09,21.63,21.63,0,0,0-.12-3.22A30.79,30.79,0,0,0,394.22,398.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.61,308.79a17.92,17.92,0,0,1-12.7-13.49c-2.38-11.12,5.29-6.35-1.59-23.82S375,250.05,377.41,245s3.71-3.44,5.82,3.17,9.8,16.94,12.71,36.26S394.61,308.79,394.61,308.79Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,290s-6.88-2.38-7.15-15.34,5-10.32,5.83-26.47,1.85-27.52,4.76-27.78,10.58,7.94,13.23,25.93-3.44,29.9-8.73,35.2S415,290,415,290Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91,324.4s-1.59-9.52-4.76-14-10.06-8.47-14.56-17.2-9.52-13-9.26-.53,5.82,18.79,12.7,23S390.91,324.4,390.91,324.4Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,340.81s-6.35-12.17-15.61-21.17-16.68-13.49-14-9,5.82,4.24,10.32,12.18,3.18,13.76,9.53,18.26S388,340.81,388,340.81Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,356.42c-.26-.79-.53-6.61-9.52-11.37s-17.47-2.92-16.41-.53,6.62,6.35,12.17,8.73S387.2,356.42,387.2,356.42Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.46,324.93s-4-5-1.85-15.61,6.88-7.94,12.17-13.49,4.23-6.35,9.53-12.18,10.05-9,12.17-6.61-1.06,9.79-4.24,14-8.2,6.35-10.58,11.65-1.32,13.76-7.41,17.73S414.46,324.93,414.46,324.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.69,327.85s9.53-10.85,16.41-18.79,9.52-14,9.79-8.74,2.38,9.53-3.18,16.41S427.69,327.85,427.69,327.85Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.66,345.31s-.26-4.23,14.82-14,21.44-11.64,19.85-7.67-8.21,7.94-15.35,15.08S422.66,345.31,422.66,345.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.24,307.66s-3.54-19-7.24-32.47-6.09-21.7-6.09-21.7",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,290.2s6.43-20.57,8.55-33-.27-21.7-1.33-27.25",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,324a99,99,0,0,0-9.75-13.89c-5.82-6.88-10.32-10.59-13-17.2",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.46,324.93s2.12-12.7,7.14-19.31,15.09-16.94,19.06-23.55",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,356.13s-8.9-5.79-15.25-9",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.1,445.73H399.45a5.11,5.11,0,0,1-4.72-3.14c-3.81-9.12-7.85-52.74-7.85-52.74h36.78s-4,43.62-7.85,52.74A5.1,5.1,0,0,1,411.1,445.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92,324.26s-5,5.27-9,3.72-6.85-4.76-11.17-1.45-1.53,9.82,3.42,16.64,8.2,10,11.85,6.54,12.64-8.09,12.94-17.08S420.9,320.55,411.92,324.26Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.05,350.29a12,12,0,0,1-7.13,4c-4.89,1-10.67-3.59-10.45,1.62s4.87,9.85,12,9.54,12.08,1.24,13.32,4,5,.31,3.41-8.06S425.55,349.06,419.05,350.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,363.93a12.69,12.69,0,0,0-5.89.31c-3.4.93-4.33,3.41-3.09,6.82s4.33,6.51,5.57,4,1.55-4,5-5S402,363.93,398,363.93Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--puzzle-pieces--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358,186.29a4,4,0,0,0-1.84,3.1,3.76,3.76,0,0,0,.63,2.32l.75,1,12.6,4.76,4.76-12.6,1-.74a3.62,3.62,0,0,1,2.31-.63,4,4,0,0,1,3.11,1.82,4.62,4.62,0,0,0,2.18,1.7c2.62,1,5.65-.57,6.76-3.5s-.12-6.14-2.74-7.13a4.74,4.74,0,0,0-2.76-.16,4.12,4.12,0,0,1-3.52-.68,3.71,3.71,0,0,1-1.33-2l-.28-1.23,4.76-12.6L371.81,155l-.73-1a3.7,3.7,0,0,1-.65-2.32,4,4,0,0,1,1.84-3.1,4.78,4.78,0,0,0,1.7-2.18c1-2.64-.58-5.68-3.52-6.79a5.43,5.43,0,0,0-7.13,2.76,4.63,4.63,0,0,0-.16,2.75,4.08,4.08,0,0,1-.67,3.54,3.92,3.92,0,0,1-2,1.33l-1.24.27-12.59-4.76L341.87,158l-1,.74a3.68,3.68,0,0,1-2.34.64,4.13,4.13,0,0,1-3.09-1.82,4.7,4.7,0,0,0-2.16-1.69,5.71,5.71,0,0,0-4,10.63,4.73,4.73,0,0,0,2.76.16,4,4,0,0,1,3.53.69,3.62,3.62,0,0,1,1.31,2l.29,1.24-4.76,12.6L344.93,188l1.25-.27a3.84,3.84,0,0,0,2-1.33,4,4,0,0,0,.66-3.53,4.75,4.75,0,0,1,.17-2.76c1-2.63,4.18-3.85,7.12-2.74s4.52,4.13,3.53,6.77A4.78,4.78,0,0,1,358,186.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.27,88.42a3.86,3.86,0,0,0-2-5.09,3.32,3.32,0,0,0-2-.11,3,3,0,0,1-2.51-.49,2.65,2.65,0,0,1-.95-1.45l-.2-.88,3.4-9-9-3.4-.53-.73a2.65,2.65,0,0,1-.46-1.66,2.89,2.89,0,0,1,1.31-2.22,3.41,3.41,0,0,0,1.22-1.55A4.09,4.09,0,0,0,412,59a3.3,3.3,0,0,0-.12,2,2.91,2.91,0,0,1-.48,2.53,2.67,2.67,0,0,1-1.45,1l-.89.2-9-3.4-3.4,9-.75.52a2.49,2.49,0,0,1-1.67.46,2.92,2.92,0,0,1-2.21-1.3,3.36,3.36,0,0,0-1.54-1.21,4.09,4.09,0,0,0-2.87,7.6,3.4,3.4,0,0,0,2,.12,2.84,2.84,0,0,1,2.52.49,2.6,2.6,0,0,1,.94,1.43l.21.88-3.41,9,9,3.4.89-.2a2.74,2.74,0,0,0,1.45-1,2.89,2.89,0,0,0,.47-2.52,3.41,3.41,0,0,1,.12-2,4.09,4.09,0,0,1,7.61,2.88,3.34,3.34,0,0,1-1.22,1.55,2.92,2.92,0,0,0-1.31,2.22,2.66,2.66,0,0,0,.45,1.65l.54.74,9,3.4,3.41-9,.73-.53a2.58,2.58,0,0,1,1.65-.45,2.88,2.88,0,0,1,2.22,1.3,3.44,3.44,0,0,0,1.56,1.22A3.86,3.86,0,0,0,431.27,88.42Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,65.49a3.8,3.8,0,0,0,2.24.28,3.39,3.39,0,0,1,2.87.74,3.18,3.18,0,0,1,1,1.74l.15,1-4.57,10.07,10.07,4.58.55.89a3,3,0,0,1,.4,2,3.4,3.4,0,0,1-1.66,2.44,3.77,3.77,0,0,0-1.5,1.68,4.7,4.7,0,0,0,8.5,3.87A3.92,3.92,0,0,0,339,92.5a3.3,3.3,0,0,1,.76-2.86,2.94,2.94,0,0,1,1.7-1l1-.18,10.08,4.58L357.14,83,357,82a3.2,3.2,0,0,0-1-1.73,3.35,3.35,0,0,0-2.86-.74,3.81,3.81,0,0,1-2.25-.28,4.7,4.7,0,0,1,3.87-8.51,3.76,3.76,0,0,1,1.69,1.51,3.33,3.33,0,0,0,2.45,1.67,3.11,3.11,0,0,0,1.93-.39l.88-.57,4.59-10.07-10.08-4.58-.55-.88a2.93,2.93,0,0,1-.39-1.93A3.3,3.3,0,0,1,357,53a3.85,3.85,0,0,0,1.51-1.7,4.7,4.7,0,0,0-8.5-3.86,3.9,3.9,0,0,0-.29,2.25,3.36,3.36,0,0,1-.74,2.85,3,3,0,0,1-1.74,1l-1,.16-10.08-4.58-4.58,10.08-.88.55a3.08,3.08,0,0,1-1.94.41,3.34,3.34,0,0,1-2.44-1.68,3.85,3.85,0,0,0-1.7-1.51,4.7,4.7,0,0,0-3.87,8.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,93.7a3.64,3.64,0,0,0,.64,2.06,3.15,3.15,0,0,1,.48,2.75,3,3,0,0,1-1.11,1.54l-.84.54H352.56v31.52h10.49l.84-.54A3,3,0,0,0,365,130a3.18,3.18,0,0,0-.48-2.76,3.66,3.66,0,0,1-.64-2.06,4.47,4.47,0,0,1,8.88,0,3.72,3.72,0,0,1-.64,2.06,3.14,3.14,0,0,0-.49,2.77,3,3,0,0,0,1.1,1.52l.84.54h10.51V121.6l.54-.82a2.88,2.88,0,0,1,1.53-1.12,3.24,3.24,0,0,1,2.76.48,3.72,3.72,0,0,0,2.06.64,4.46,4.46,0,0,0,0-8.87,3.69,3.69,0,0,0-2.06.64,3.21,3.21,0,0,1-2.77.49,3,3,0,0,1-1.52-1.12l-.54-.82V100.59H373.57l-.84-.54a3,3,0,0,1-1.1-1.52,3.14,3.14,0,0,1,.49-2.77,3.72,3.72,0,0,0,.64-2.06,4.47,4.47,0,0,0-8.88,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.41,136.32a3.41,3.41,0,0,0-2-.12,2.93,2.93,0,0,1-2.52-.48,2.68,2.68,0,0,1-.95-1.45l-.2-.88,3.41-9-9-3.4-.52-.73a2.68,2.68,0,0,1-.47-1.66,2.87,2.87,0,0,1,1.32-2.22,3.3,3.3,0,0,0,1.21-1.56,4.09,4.09,0,0,0-7.61-2.87,3.3,3.3,0,0,0-.11,2,3,3,0,0,1-.48,2.53,2.8,2.8,0,0,1-1.45.95l-.89.19-9-3.4-3.41,9-.74.52a2.6,2.6,0,0,1-1.67.46,3,3,0,0,1-2.21-1.3,3.28,3.28,0,0,0-1.55-1.21,4.09,4.09,0,0,0-2.87,7.6,3.49,3.49,0,0,0,2,.12,2.86,2.86,0,0,1,2.53.49,2.58,2.58,0,0,1,.93,1.43l.21.88-3.4,9,9,3.4.89-.19a2.72,2.72,0,0,0,1.45-.95,2.9,2.9,0,0,0,.48-2.52,3.33,3.33,0,0,1,.12-2,4.09,4.09,0,0,1,7.61,2.87,3.39,3.39,0,0,1-1.22,1.56,2.86,2.86,0,0,0-1.31,2.22,2.68,2.68,0,0,0,.45,1.65l.54.74,9,3.4,3.4-9,.73-.53a2.6,2.6,0,0,1,1.66-.45,2.89,2.89,0,0,1,2.22,1.3,3.34,3.34,0,0,0,1.56,1.22,4.09,4.09,0,0,0,2.87-7.6Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.45,276.46c-.35-2.78,5.65-10.92,10.87-17.38,38.23-47.44,40.15-129.56,3-180.33a3.5,3.5,0,0,0-.59.85l-.59,1.26,2.12,14.64-14.65,2.12-1,.92a4,4,0,0,0-1.24,2.36,4.48,4.48,0,0,0,1.21,3.74,5.17,5.17,0,0,1,1.31,2.74c.44,3.05-2,5.93-5.39,6.43s-6.53-1.6-7-4.64a5.17,5.17,0,0,1,.48-3,4.42,4.42,0,0,0,.1-4,4,4,0,0,0-1.83-1.89L264,99.73l-14.64,2.11-2.12-14.65.59-1.27a4.24,4.24,0,0,1,1.9-1.84,4.4,4.4,0,0,1,3.95.13,5.22,5.22,0,0,0,3,.47c3.07-.44,5.13-3.57,4.64-7s-3.36-5.84-6.42-5.39a5.16,5.16,0,0,0-2.74,1.3,4.47,4.47,0,0,1-3.75,1.24,4.31,4.31,0,0,1-2.36-1.25l-.92-1L243,57.92l14.65-2.11,1-.94a4,4,0,0,0,1.23-2.32,4.41,4.41,0,0,0-1.22-3.77,6,6,0,0,1-.44-.56q-3-1.71-6.21-3.23c-36.62-17.42-79.89-20.38-118.62-8.49-49.93,15.33-71,49.27-83.17,98.07-3.81,15.26-6.67,20-3.81,25.75s8.58,13.36,6.68,19.08-16.22,34.35-21.95,42-6.68,13.36-2.86,18.13,18.13,6.68,18.13,6.68.07,7.32-3.19,13.36-.51,6.05,0,8.6-1.84,4.88-1.37,8.6,2.26,5.64,4.63,7.79S44.37,304.07,44.06,309s5.26,17.49,9.45,20.74,12.08,4.19,15.34,4.65,20,1.86,22.78,2.79,17.2,17.67,23.71,26,28.82,33.47,30.21,42.31c.71,4.51,6.48,23.46,11.94,40.9h244c-31.27-35.81-81.47-94-92.07-112.21C294.25,308.07,279.06,281.32,278.45,276.46ZM186,84.58A3.94,3.94,0,0,0,183.85,83a4.39,4.39,0,0,0-3.9.67,5.34,5.34,0,0,1-2.91.9c-3.09,0-5.6-2.79-5.6-6.23s2.51-6.26,5.6-6.26a5.23,5.23,0,0,1,2.89.9,4.49,4.49,0,0,0,3.88.67A3.92,3.92,0,0,0,186,72.11l.79-1.15V56.16h14.77l1.18-.77a4.17,4.17,0,0,0,1.57-2.15,4.48,4.48,0,0,0-.69-3.9,5.09,5.09,0,0,1-.9-2.88c0-3.1,2.8-5.61,6.25-5.61s6.26,2.51,6.26,5.61a5.21,5.21,0,0,1-.91,2.9,4.44,4.44,0,0,0-.68,3.9,4,4,0,0,0,1.57,2.13l1.15.77h14.8V71l.77,1.15A4,4,0,0,0,234,73.68a4.49,4.49,0,0,0,3.88-.67,5.23,5.23,0,0,1,2.9-.9c3.08,0,5.59,2.79,5.59,6.26s-2.51,6.23-5.59,6.23a5.18,5.18,0,0,1-2.9-.9A4.41,4.41,0,0,0,234,83a3.91,3.91,0,0,0-2.13,1.55l-.77,1.15v14.8h-14.8l-1.17-.76a4.14,4.14,0,0,1-1.55-2.14,4.45,4.45,0,0,1,.68-3.9,5.16,5.16,0,0,0,.91-2.9c0-3.1-2.81-5.59-6.26-5.59s-6.25,2.49-6.25,5.59a5.16,5.16,0,0,0,.9,2.9,4.44,4.44,0,0,1,.69,3.88,4.2,4.2,0,0,1-1.57,2.16l-1.18.76H186.75V85.73Zm83,67.64a5.16,5.16,0,0,1-2.9-.91,4.43,4.43,0,0,0-3.9-.66,3.91,3.91,0,0,0-2.13,1.55l-.77,1.15v14.8h-14.8l-1.17-.76a4.14,4.14,0,0,1-1.55-2.14,4.43,4.43,0,0,1,.69-3.9,5.23,5.23,0,0,0,.9-2.9c0-3.1-2.81-5.59-6.26-5.59s-6.25,2.49-6.25,5.59a5.23,5.23,0,0,0,.9,2.9,4.44,4.44,0,0,1,.69,3.88,4.2,4.2,0,0,1-1.57,2.16l-1.17.76H214.92v-14.8l-.79-1.15a3.94,3.94,0,0,0-2.11-1.55,4.41,4.41,0,0,0-3.9.66,5.26,5.26,0,0,1-2.9.91c-3.1,0-5.61-2.79-5.61-6.24s2.51-6.25,5.61-6.25a5.14,5.14,0,0,1,2.88.9,4.49,4.49,0,0,0,3.88.67,4,4,0,0,0,2.15-1.57l.79-1.16V123.78H229.7l1.17-.77a4.17,4.17,0,0,0,1.57-2.15,4.48,4.48,0,0,0-.69-3.9,5.18,5.18,0,0,1-.9-2.89c0-3.09,2.81-5.6,6.25-5.6s6.26,2.51,6.26,5.6a5.23,5.23,0,0,1-.9,2.9,4.44,4.44,0,0,0-.69,3.91,4,4,0,0,0,1.57,2.13l1.15.77h14.8v14.79l.77,1.16a4,4,0,0,0,2.15,1.57,4.48,4.48,0,0,0,3.88-.67,5.2,5.2,0,0,1,2.9-.9c3.08,0,5.59,2.78,5.59,6.25S272.07,152.22,269,152.22Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 458.93,
    y1: 446.42,
    x2: 471.8,
    y2: 446.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.73,
    y1: 446.42,
    x2: 451.5,
    y2: 446.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.54,210.31s-24.78-10.25-26.93-11.44-4.29-5.72-5.24-6.67-2.62-.48-6.43-1.19-6.2-3.58-6.67-1.43.95,2.85,2.14,3.33,3.57,1.67,3.57,1.67l.24,1.67a90.88,90.88,0,0,1-10.72,1.43c-3.1,0-5.24,1.19-4.77,2.62s2.86.71,2.86.71l5.72-.24s-9.05,2.39-9.29,3.58,1.43,2.14,2.14,1.91,4.53-1.43,4.53-1.43l2.38-.48s-4.52,2.62-4.28,4.29,2.85.47,2.85.47l2.63-2.62,3.81-.71L212,209.83s.47,1.43,1.67,1.19,2.86-2.38,2.86-2.38l3.09-.72a9.19,9.19,0,0,0,2.62,0c.72-.24,4.53-1.43,4.53-1.43s23.11,16.68,26,17.4,10.25,6.43,14.3,5,0-12.39,0-13.58S257.54,210.31,257.54,210.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.38,398.45s4.53,16,7.46,22.62,7.69,14.57,8.78,17.3-1.86,5.85-3.73,6.65a14.43,14.43,0,0,0-5.85,3.73c-1.86,2.13-8.52,5.85-12.78,6.12s-10.91.8-9.31-3.46,10.11-10.91,10.91-13.31a9,9,0,0,0,.53-4l-6.65-14.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,431c-2.61,2.12-6.15,4.85-8.17,5.78-3.46,1.6-8-.53-8-.53l-.32-.16a10.9,10.9,0,0,1-.48,2c-.8,2.4-9.31,9-10.91,13.31s5.06,3.73,9.31,3.46,10.92-4,12.78-6.12a14.43,14.43,0,0,1,5.85-3.73c1.87-.8,4.79-4,3.73-6.65C234.06,437,232.55,434.23,230.81,431Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,253.47l-7.07,22.2s8.24,1.18,10.77,3.87c0,0,4.37-13.62,5.21-18.67S165.28,249.77,160.57,253.47Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,275.67s-8.07,8.75-9.25,9.59a5.72,5.72,0,0,0-1.68,4.88c.34,1.51,1.35,6.05,2.19,6.39s12.44-.84,13.45-1.69,2.19-4.87,2.36-6.39.17-4.2.17-4.2l2.85-7.4S155.86,275,153.5,275.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87,317.59H126.44a2.5,2.5,0,0,1,0-5h48.43a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,396.81a2.43,2.43,0,0,1-.65-.09,2.5,2.5,0,0,1-1.77-3.06l.92-3.42a22.24,22.24,0,0,1,21.43-16.42h21.58a22.19,22.19,0,0,1,21.47,16.6l.67,2.57a2.5,2.5,0,1,1-4.84,1.25l-.67-2.56a17.19,17.19,0,0,0-16.63-12.86H139.11a17.22,17.22,0,0,0-16.6,12.72l-.92,3.42A2.51,2.51,0,0,1,119.18,396.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69,458.71l-.26,0A2.5,2.5,0,0,1,109.2,456l15.27-147.23A23.2,23.2,0,0,1,147.75,288h6.69a23.35,23.35,0,0,1,23.34,21.31l10.62,139.1a2.5,2.5,0,1,1-5,.38l-10.63-139.1A18.32,18.32,0,0,0,154.44,293h-6.69a18.22,18.22,0,0,0-18.31,16.21L114.18,456.47A2.51,2.51,0,0,1,111.69,458.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,464.23l-.37,0a3.5,3.5,0,0,1-3.12-3.84l.47-4.52a3.5,3.5,0,0,1,7,.72l-.47,4.52A3.49,3.49,0,0,1,111.23,464.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,454.17a2.21,2.21,0,0,1-.37,0,3.49,3.49,0,0,1-3.71-3.27l-.28-4.54a3.5,3.5,0,1,1,7-.43l.29,4.53A3.5,3.5,0,0,1,186.64,454.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,298.91s5.22.25,6.34-.53,2-6.1,1.79-7.3-1.22-.62-2,.84a23.71,23.71,0,0,0-1.51,5.27l-1.73.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.49,299.44s5.23.24,6.34-.54,2-6.09,1.79-7.3-1.21-.62-2.05.85a23.52,23.52,0,0,0-1.51,5.26l-1.73.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76,296.53s5.38,2.52,6.89,2.18,4.71-5.55,5-6.89-1-1.18-2.52,0-3.87,4.87-3.87,4.87l-1.85-.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76,296.53s1.68,2.86,3.19,2.52,4.71-5.55,5.05-6.9-1-1.17-2.52,0-3.87,4.88-3.87,4.88l-1.85-.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.65,280.21s-2.86,6.23-3,7.23-2.36,8.92-2,9.59,2.18.34,2.86-.5,2.35-5.55,2.69-6.23,2.86-2,3.87-3.53,1.85-5.38,1.85-5.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.07,282.72s3.64,39.91,7.12,51.63,20.4,42.13,21.06,43.86,2.17,5.43,2.82,16.29.39,19.18.39,24.61-3.87,22-3.87,22a32.6,32.6,0,0,1-8.25,3.26c-4.12.87-10,2.61-10,5.21s15.63,5.86,21.06,6.95,11.72,2.17,13.24.65,1.09-3,2-8.47,1.92-5.64,5-17.15,6.8-18.66,8.54-32.13-.52-26,1.22-35.78,8-39.54,11.52-56.91,3.69-18.46,1.95-29.31l-72.89-1.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,372.09c-.33-6-.27-15.08,1.14-21.89,1.73-8.29,3.29-53.63,3.29-53.63",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,380.52c-.24.3-.69-3.62-.92-6.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.62,
    y1: 299.83,
    x2: 188.19,
    y2: 294.83,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,457.14c1.41-1.41,1.14-2.82,1.79-7.33-4.41-.29-7.82-4.35-10.42-6.44a11.1,11.1,0,0,0-7.44-2.3,32.6,32.6,0,0,1-8.25,3.26c-4.12.87-10,2.61-10,5.21s15.63,5.86,21.06,6.95S203.14,458.66,204.66,457.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.61,227.74s4.12,13,3.9,18.46-7.16,25-7.16,25a138,138,0,0,1-1.3-20C161.05,239.25,165.61,227.74,165.61,227.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59,174.76l-5.21,4.78s1.73,15.2-1.52,26.92-10.21,26.27-8.9,31,2.17,7.82,2.17,9.55-2.17,13.47-4.78,24.1-1.28,11.56-1.28,11.56,24.3,3,44.49,3,25-2.82,25-2.82-8.9-53.41-8.9-69.26S217,176.4,217,176.4l-10.74-4.68S193,165,180.59,174.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.73,247.31c1.09.39,2.19.74,3.32,1.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.47,236.86a76.14,76.14,0,0,0,16.09,9.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,242.94a45.22,45.22,0,0,0,15.2,5.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,238.6s9.12,4.77,16.5,6.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,127.44a21.47,21.47,0,0,1,.56,7.85c-.56,3.92-.75,5.79.37,9s2.81,4.85,1.5,10.83-4.3,12-5.42,13.27a50.8,50.8,0,0,1-4.67,4.11L217,176.4s-.94,7.28-7.1,11.39-15.33,5.24-21.68,2.06-9.9-13.64-9.9-13.64l7.84-5.79-1.49-8L176,151l8.79-9.34s1.68-6.91,10.09-12.89,13.26-5.8,16.07-5.42S216.2,127.44,216.2,127.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,132.86a7.8,7.8,0,0,0-1.49,4.48c-.19,3,4.67,11.4,4.29,12.34s-5,2.42-5,2.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.53,
    y1: 158.83,
    x2: 215.08,
    y2: 158.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.6,134.54s-6.16-.93-9,3.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.28,143.14s-.74,3-6.16,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,140.15c0,1.13-.46,2-1,2s-1-.92-1-2,.46-2.06,1-2.06S208.16,139,208.16,140.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.38,120.71c-.94-5.6-5-4.67-6.17-6.16s-1.12-5.24-5.61-8.23-14-.18-16.44-.37-8-.19-10.09,2.8l-2.06,3s-5.79-.56-9.71,6.17-4.86,12.14-3.37,16.63,1.12,8,.56,8.22-4.11-2.8-6.35,2.8.93,12.71,5.61,13.46,8.59-1.68,8.78,1.12,0,4.3,3.74,5,6.35-2.8,6.35-2.8-5.05-8.22-5.79-12l5.23-6.16s.93,3.73,3,3.73,1.68-2.61,2-5.42c1.87-1.12-.37-3.92.19-6s3.74-4.67,5.05-4.11a10.43,10.43,0,0,0,8.78-.56c4.11-2,2.61-6.16,4.11-6.35s.75,4.3,4.67,4.48S220.31,126.32,219.38,120.71Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#a1a1a1",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,162.38s2.8,1.5,3.55-3.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.09,169.11s-7.1,2-10.47-1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.11,
    y1: 170.42,
    x2: 187.24,
    y2: 178.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.54,172.47s-5.42,2.81-6.73,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27,176.21s-17.2,11.77-22.24,17-3.55,14.95-.93,20.75,5.6,14.57,5.6,14.57-2.8,6.73-1.68,21.12,2,32.32,2,33.07,2.43-17,2.43-17-.37-15,.38-21.12,2.8-10.46,8.78-27.09,7.1-26,7.1-29.53S178.27,176.21,178.27,176.21Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,176.4s-2.06,33.44-1.31,44.47,13.08,63,13.08,63h15.13s-4.11-30.83-5.23-39.43-2.24-11-2.24-11-.93-13.46-.56-29.15-.94-16.82-3.74-19.81S217,176.4,217,176.4Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,221.24s12.15,23.92,12.71,27.85-9.72,28.58-9.72,28.58a85.82,85.82,0,0,1,8.22,3.37,42.45,42.45,0,0,1,5.23,3.55s14.21-20.74,14.58-32.51-6.17-27.29-8.41-33.64-8.59-25.6-13.64-29.9-13.64-7.66-13.64-7.66",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.51,277.67s-6,4.28-8.2,5.89-3,7.9-3.46,9-2.47,2.84-1.24,3.21,4.08-1.48,5.19-3.33,1.24-2,1.48-2.47,2.72-1,3.34-1,5.56,2.1,8.89,1.85,7.45-6.25,7.45-6.25S244.32,279.2,234.51,277.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,317.59H209.47a2.5,2.5,0,1,1,0-5H257.9a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.21,396.81a2.51,2.51,0,0,1-2.42-3.15l.92-3.42a22.22,22.22,0,0,1,21.43-16.42h21.58a22.19,22.19,0,0,1,21.47,16.6l.67,2.57a2.5,2.5,0,1,1-4.84,1.25l-.67-2.56a17.19,17.19,0,0,0-16.63-12.86H222.14a17.22,17.22,0,0,0-16.6,12.72l-.92,3.42A2.51,2.51,0,0,1,202.21,396.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.8,317.59H126.44a2.5,2.5,0,0,1,0-5H207.8a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,458.71l-.26,0a2.49,2.49,0,0,1-2.23-2.74l15.26-147.23A23.2,23.2,0,0,1,230.77,288h6.7a23.37,23.37,0,0,1,23.34,21.31l10.62,139.1a2.5,2.5,0,1,1-5,.38l-10.63-139.1A18.32,18.32,0,0,0,237.47,293h-6.7a18.2,18.2,0,0,0-18.3,16.21L197.2,456.47A2.5,2.5,0,0,1,194.72,458.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.25,464.23l-.36,0a3.49,3.49,0,0,1-3.12-3.84l.46-4.52a3.5,3.5,0,0,1,7,.72l-.47,4.52A3.51,3.51,0,0,1,194.25,464.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,285.41l-1.61,5.68s-3.58,5.31-2.84,6.05,1.85,1,2.35.5,4.57-3.83,4.94-5.07,2.1-8,2.1-8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,285.41s-1.36,7.16-1.86,8.27-5.55,4.08-6.54,4.45a3.65,3.65,0,0,1-2.47-.49l4.81-4,2.23-9.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,284.59s-1.28,6.25-1.28,7.24-4.44,4.45-6.17,4.82-3.95,1-3.95,1,3.7-2.6,4.32-4,.74-6.05.74-6.05",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.84,286.4s-1.11,7-1.6,8.15-4.08,2.22-5.68,3.09a2.3,2.3,0,0,1-2.72-.25l4.32-3.71,1.86-8.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.31,457.09a3.49,3.49,0,0,1-3.48-3.23l-.38-5a3.5,3.5,0,1,1,7-.53l.38,5a3.5,3.5,0,0,1-3.23,3.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.06 203.16 255.87 210.07 264.45 214.59 265.88 205.3 257.06 203.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,273.8s-1.65,26.77,1.64,52.71,13.18,88.71,13.59,91.18,1.65,18.95,1.65,20.18S268.5,449,264,453.11s-8.65,4.94-4.94,7.41,9.85,2.86,13.78,2.05,9.69-4.93,9.69-4.93l4.74-3.66.25-.16c.66-.3,3.54-1.63,5.71-2.36,2.47-.82,2.89-4.94,2.47-10.29-.39-5.13-3.81-20.09-4.09-21.33a1,1,0,0,1,0-.17c-.21-2.28-4.48-59.06-2.88-78.75C290.32,320.74,292,294,292,294h13.59c3.29,0,11.53-5.36,11.53-5.36L318.32,275s-23.06,1.23-34.59-1.24-25.94-6.59-25.94-6.59Z",
    style: {
      fill: "#8a8a8a",
      stroke: "#636363",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.18,443.16a9.32,9.32,0,0,1-4.95-3.26,1.38,1.38,0,0,0-2.29.29c-1.71,3.5-5.58,9.83-9,12.92-4.53,4.12-8.65,4.94-4.94,7.41s9.85,2.86,13.78,2.05,9.69-4.93,9.69-4.93l4.74-3.66.25-.16c.66-.3,3.54-1.63,5.71-2.36s2.78-4.1,2.58-8.63a1.38,1.38,0,0,0-1.69-1.28C290.81,442.31,283.34,443.87,280.18,443.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,274.21s-12.12,72.4-12.12,75.69,5.59,44.81,4.58,64.62c-.22,4.13-1.11,20.47-1.93,26.23s-.83,11.12-1.24,13.59-3.29,12.77-10.29,16.06-11.95,3.71-14.42,1.24,1.24-5.77,4.12-11.12a22.66,22.66,0,0,0,2.87-8.71,1.45,1.45,0,0,0-.1-.62c-.43-1.06-1.94-4.9-1.94-6.32,0-1.64,2.47-4.53,2.05-9.47s-9.88-63.18-10.29-83.36-.82-61.36-.82-61.36l-9.47-3.7",
    style: {
      fill: "#8a8a8a",
      stroke: "#636363",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.32,170.27s-12.39,27.65-12.15,35.51-9.92,66.73-9.92,66.73,15.4,6.25,24.93,6.49,17.4.23,17.4.23-1.91-61.54-.24-72.5S309,171.94,309,171.94Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.61,176s2.38,4.53,10,6,12.4-1.67,12.4-1.67l4.52-20-14.06-4.77-7.56,4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8,157.65S274,160.27,269.93,161s-7.62,2.38-9.05,11.2-3.82,31-3.82,31l6.44,3.1s-.72,8.1,0,12.15-9.07,60.82-9.07,60.82l8.1,3.34s5.73-40.81,7.4-53.68,1.43-17.63,4.77-29.31,14.29-36.69,14.53-37.41,1.67-5.24,1.67-5.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.12,179.33l1.19,7.62s-3.1,14.3-3.81,19.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.64,190.66c-.52,1.66-1,3.29-1.37,4.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,161.93a217.69,217.69,0,0,0-10.92,24.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8,161.46s-7.87,11.91-9.06,18.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,169.76c.11-4.7-2.08-10.23-2.08-10.23s-5.47,2.28-8-.23-4.79-10-5.48-14.15-2.05-19.62-2.05-19.62l0-3.73s32.48-15.83,34.08-14.23-11,9.76-11,10.44,5.62,14.92,7.68,13.43,7.81-7.46,9.41-2.3.46,13.89-1.37,15.72-3.56,3.1-4.25,5.86a12.1,12.1,0,0,1-1.26,3.55s2.18,4.13,1.15,13.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.91 159.53 294.47 155.5 288.75 165.03 286.91 159.53",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.79,136s0,1.82-1.83,6.16l-1.82,4.33a5.06,5.06,0,0,0,5.47.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,151.09s2.28.68,3.43,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,137.29c0,1-.49,1.78-1.09,1.78s-1.09-.8-1.09-1.78.49-1.78,1.09-1.78S286,136.31,286,137.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.42,136.49c0,1-.48,1.78-1.09,1.78s-1.09-.8-1.09-1.78.49-1.78,1.09-1.78S276.42,135.51,276.42,136.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.45,131.67a5.13,5.13,0,0,1,5.85,1.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,132.13a2.65,2.65,0,0,0-3.9.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,111.84A126.73,126.73,0,0,0,286,118c-4.56,2.74-14.6,7.53-14.6,7.53s-5-1.6-6.62-6.39,12.55-16.2,20.76-19.39,14.61-.23,24,3.42,12.55,14.15,16.43,23.27,3,15.75.68,20.31A29.46,29.46,0,0,1,313.84,160c-6.39,3.2-13-2.51-13.69-4.33a32.46,32.46,0,0,1-1.14-3.88s4.79-.68,5.24-2.05,1.14-5.25,1.14-5.25a28.62,28.62,0,0,0,3.65-4.11c2.29-3.19,2.51-10.49-.45-10.72s-6.39,4.79-6.39,4.79-5.7-3.65-8.9-8.44-3.88-7.53-3.88-7.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.63,160s-5.48,22.64-9.77,35-3.1,27.4-2.39,39.79,4.33,53.35,4.33,53.35,14.53-2.15,19.06-4.53a110,110,0,0,0,11.67-7.86s-8.09-43.37-8.33-44.08-.95-6.67-.95-6.67,10.2-51,7.58-55S306.63,160,306.63,160Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.81,222.22l-.95,1.67s-26.45,6.43-30.26,6.43-9.29.72-10.72,0-6.2-5.24-8.11-6.43-3.57-.72-6.19-1.67-3.81-4.53-5-2.62.72,4.29,1.67,5,4.53,2.62,4.53,2.62-10.15,4.95-11.39,6.17a3.71,3.71,0,0,0-1.24,2.41l2.15,2.15s.47,3.09,1.19,3.81,2.14,1.91,2.14,1.91a1.69,1.69,0,0,0,1.43,1.66c1.43.24,2.62,0,6.67-.23S263,241,263,241s23.59.48,28.12.48,24.59-.48,26-1.67,4.95-15.72,4.95-15.72S308.29,217.93,302.81,222.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.68,183.86l-7.87,38.36a30.58,30.58,0,0,1,7.39,1.19,48.65,48.65,0,0,1,9.53,4.29s1.67-.24,2.38-3.57,1.91-9.3,1.91-9.3,8.58-24.54,9.29-30-.71-13.82-3.09-16.44-15.49-4.05-15.49-4.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.19,
    y1: 217.61,
    x2: 308.93,
    y2: 187.49,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,212.45l-.15,0-2.95,11.4a16,16,0,0,1,7.25.5c4.29,1.19,12.05,5.49,12.05,5.49a11,11,0,0,0,3.31-5.52c.45-2.1.49-7.92-.45-9.53C315.17,205.43,305,212.45,305,212.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,453.37a1.38,1.38,0,0,0-2-1.37c-2.85,1.46-6.37,3-8.33,3a11,11,0,0,1-5.68-2.15,1.37,1.37,0,0,0-2.13.85,25.71,25.71,0,0,1-2.58,6.79c-2.88,5.35-6.59,8.65-4.12,11.12s7.42,2.06,14.42-1.24,9.88-13.59,10.29-16.06C311,454.06,311,453.73,311,453.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.33,115.09a33.12,33.12,0,1,0-6.1,6.82l10.2,2.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,112.74a33.08,33.08,0,1,0-6.1,6.82l10.2,2.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,101.48V95.1a25.66,25.66,0,0,0,4-3.86,18.12,18.12,0,0,0,2.82-4.52,12.41,12.41,0,0,0,1-5,4.12,4.12,0,0,0-.67-2.64,2.34,2.34,0,0,0-2-.82,2.48,2.48,0,0,0-1.86.69,2.71,2.71,0,0,0-.66,1.93,5,5,0,0,0,.17,1.41c.12.41.26.85.42,1.31l-7.27,1.68a18.3,18.3,0,0,1-.61-2.3,11.78,11.78,0,0,1-.23-2.35,8.76,8.76,0,0,1,2.65-6.79q2.64-2.45,7.59-2.45c3.32,0,5.89.87,7.68,2.62s2.7,4.23,2.7,7.46a16.09,16.09,0,0,1-1,5.64,18,18,0,0,1-2.89,5,26.52,26.52,0,0,1-4.62,4.45v4.85ZM113.53,112v-7.67h7.86V112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,112v-7.52h7.62V112Zm2.47-10.19-2.32-29.76h8l-2.92,29.76Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.072d7542a0fdddb4829291d52d66fdc1.svg";
export { ForwardRef as ReactComponent };